module.exports = __webpack_public_path__ + "static/how-the-iot-ai-and-robotics-can-help-keep-workplaces-clean-and-safe-8ee24350c873aeaaa65bee2b0e7e8395.png";